import { gql, TypedDocumentNode } from '@common/hooks';
import {
  PaginatedWorksShiftsQueryCgResponse,
  PaginatedWorksShiftsQueryVariables,
  WorksShiftRejectionReasonsQueryCgResponse,
  WorksShiftRejectionReasonsQueryVariables,
} from '@common/graphql/schema';

export type WorksShiftRejectionReasonsResponse = {
  worksShiftRejectionReasons: [
    {
      id: string;
      code: string;
      displayName: string;
    },
  ];
};

export const WorksShiftRejectionReasons: TypedDocumentNode<
  WorksShiftRejectionReasonsQueryCgResponse,
  WorksShiftRejectionReasonsQueryVariables
> = gql`
  query WorksShiftRejectionReasons($reasonType: String) {
    worksShiftRejectionReasons(reasonType: $reasonType) {
      id
      code
      displayName
    }
  }
`;

export const PaginatedWorksShiftsQuery: TypedDocumentNode<
  PaginatedWorksShiftsQueryCgResponse,
  PaginatedWorksShiftsQueryVariables
> = gql`
  query PaginatedWorksShifts(
    $limit: Int!
    $offset: Int!
    $workerId: ID
    $orderField: WorksShiftOrder
    $orderDirection: OrderDirection
    $filters: WorksShiftsFilterInput
  ) {
    paginatedWorksShifts(
      workerId: $workerId
      limit: $limit
      offset: $offset
      orderField: $orderField
      orderDirection: $orderDirection
      filters: $filters
    ) {
      worksShifts {
        id
        startDatetime
        perHourIncentivePay
        status
        showUnitName
        lastStateChangeDatetime
        duration
        shiftGap {
          id
          timeZone
          startDatetime
          role {
            id
            abbreviation
          }
          organizationUnit {
            id
            name
            costCenter
          }
        }
        createdAt
      }
      totalCount
    }
  }
`;
